import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  between?: boolean
}

const PageBottom = ({ children, between = false }: Props) => {
  return (
    <div className={clsx('flex pb-4 pt-8', between ? 'justify-between' : 'justify-end')}>
      {children}
    </div>
  )
}

export default PageBottom
